import React from 'react';

export interface OptionCheckboxProps {
  option: any;
  onChangeHandler: any;
  size?: 'default' | 'small';
  labelPosition?: 'left' | 'right';
}

const optionCheckbox: React.FC<OptionCheckboxProps> = ({
  option,
  onChangeHandler,
  size = 'default',
  labelPosition = 'left',
}) => {
  const sizeClass = size === 'small' ? 'option-item--small' : '';
  const labelRightClass =
    size === 'small' && labelPosition === 'right' ? 'option-item--label-right' : '';

  const label = <span className="toggler-label">{option.displayName}</span>;
  const toggle = (
    <label className="toggler-wrapper">
      <input
        type="checkbox"
        name={option.actionName}
        defaultChecked={option.isChecked}
        onChange={onChangeHandler}
      />
      <div className="toggler-slider">
        <div className="toggler-knob"></div>
      </div>
    </label>
  );

  return (
    <>
      <div className={`option-item ${sizeClass} ${labelRightClass}`.trim()}>
        {labelPosition === 'left' ? (
          <>
            {label}
            {toggle}
          </>
        ) : (
          <>
            {toggle}
            {label}
          </>
        )}
      </div>
    </>
  );
};

export default optionCheckbox;
